import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { GerenciaArquivoUsuario } from 'src/app/@shared/models/gerencia-arquivo/gerencia-arquivo';
import { InserirUsuarioInput } from 'src/app/@shared/models/usuario.model';
import { StorageService } from 'src/app/services/storage/storage.service';
import { GerenciaArquivoService } from '../gerencia-arquivo.service';


@Component({
  selector: 'app-modal-permissao-arquivo',
  templateUrl: './modal-permissao-arquivo.component.html',
  styleUrls: ['./modal-permissao-arquivo.component.scss']
})
export class ModalPermissaoArquivoComponent implements OnInit {
  public form: FormGroup;
  public listaUsuarios: InserirUsuarioInput[] = [];
  public listaUsuariosPermitidos: GerenciaArquivoUsuario[] = [];

  public displayedColumns = ['nome', 'usuario', 'action']

  filteredOptions: Observable<InserirUsuarioInput[]>;

  constructor(public dialog: MatDialogRef<ModalPermissaoArquivoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    private fb: FormBuilder,
    private gerenciaArquivoService: GerenciaArquivoService) { }

  ngOnInit() {
    this.form = this.fb.group({
      usuario: ['', [Validators.required]]
    });

    this.atualizaUsuarios();

    this.gerenciaArquivoService.obterUsuarioPorClienteId(this.data.id).subscribe(obj => {
      this.listaUsuarios = obj;
    }, error => {
      console.log(error);
    })

    this.filteredOptions = this.form.get('usuario').valueChanges.pipe(
      startWith(''),
      map(value => (typeof value === 'string' ? value : value.nome)),
      map(nome => (nome ? this._filter(nome) : this.listaUsuarios.slice())),
    );
  }

  private _filter(nome: string): InserirUsuarioInput[] {
    const filterValue = nome.toLowerCase();
    return this.listaUsuarios.filter(item => item.nome.toLowerCase().includes(filterValue));
  }

  displayFn(user: InserirUsuarioInput): string {
    return user && user.nome ? user.nome : '';
  }

  salvar() {
    if (this.form.dirty && this.form.valid) {
      let p = Object.assign({}, this.form.value);

      let arquivoUsuario = new GerenciaArquivoUsuario();
      arquivoUsuario.gerenciaArquivoId = this.data.arquivoId;
      arquivoUsuario.usuarioCadastro = StorageService.getPerfilUsuario().username;
      arquivoUsuario.usuario = p.usuario.login;

      if (arquivoUsuario.usuario != undefined) {
        console.log(arquivoUsuario);
        this.gerenciaArquivoService.registraArquivoUsuario(arquivoUsuario)
          .subscribe(() => {
            this.openSnackBar("Adicionado com sucesso");
            this.atualizaUsuarios();
          }, error => {
            console.log(error);
          })
      }
    }
  }

  atualizaUsuarios() {
    this.gerenciaArquivoService.obterGerenciaArquivoUsuarioPorArquivoId(this.data.arquivoId)
      .subscribe(obj => {
        this.listaUsuariosPermitidos = obj;
      }, error => {
        console.log(error.errors)
      })
  }

  deletaPermissao(id: number) {
    if (id == null) return;
    this.gerenciaArquivoService.removeArquivoUsuario(id).subscribe(obj => {
      this.atualizaUsuarios();
      this.openSnackBar("Arquivo removido com sucesso");
    }, error => {
      console.log(error);
    })
  }

  openSnackBar(message: string): any {
    this.snackBar.open(message, null, { duration: 5000 });
  }

}
